import {css, html, LitElement} from 'lit';
import {customElement, queryAssignedElements, property, state} from 'lit/decorators.js';
import {iconsFont} from '../../ts/css/icons.styles';
import styles from './infobox.styles';
import Tracking2 from '../../ts/services/tracking2';

@customElement('ui-infobox')
export class Infobox extends LitElement {
  static styles = styles;

  connectedCallback() {
    super.connectedCallback();
    Tracking2.bindTrackingExposeHandler(this);
  }

  render() {
    return html`<div class="panels"><slot></slot></div>`;
  }
}

@customElement('ui-infobox-panel')
export class InfoboxPanel extends LitElement {
  static readonly styles = [css`
    .content {
        display: block;
        overflow: hidden;
    }

    .open .content {
      transition: height 500ms;
    }

    .toggle {
        display: inline-flex;
        gap: 1rem;
        align-items: center;
        cursor: pointer;
        color: var(--system-hyperlink);
        font-size: 1.4rem;
        line-height: 1.6rem;
        text-transform: capitalize;
    }

    .toggle:hover {
      background-color: var(--link-bg-hover);
    }

    .icon.icon-arrow-down {
        font-size: inherit;
        line-height: inherit;
    }
    `, iconsFont];

  @property() toggleText = 'Mehr Informationen';

  @state() height = 60;
  @state() showToggle = false;

  @queryAssignedElements({slot: 'content', selector: 'ul'}) list: HTMLUListElement[];

  private listToDisplay = 0;
  private maxListToDisplay = 0;
  private calculatedMinHeight = 0;
  private calculatedMaxHeight = 0;

  get componentPath() {
    return this.getAttribute('data-component-path') ?? this.parentElement?.getAttribute('data-component-path') ?? '';
  }

  slotContentChangeHandler() {
    const listItems = this.list[0].querySelectorAll('li');
    this.maxListToDisplay = listItems.length;
    this.listToDisplay = Math.min(this.maxListToDisplay, 2);

    for (let i = 0; i < this.maxListToDisplay; i++) {
      if (i < this.listToDisplay) {
        this.calculatedMinHeight += listItems[i].getBoundingClientRect().height;
      }
      this.calculatedMaxHeight += listItems[i].getBoundingClientRect().height;
    }

    this.calculatedMinHeight += (this.listToDisplay * 10); // include gap between li items
    this.calculatedMaxHeight += (this.maxListToDisplay * 10);

    this.height = this.calculatedMinHeight;
    this.showToggle = this.listToDisplay < this.maxListToDisplay;
  }

  toggleClickHandler(e: Event) {
    e.preventDefault();
    this.showToggle = false;
    this.height = this.calculatedMaxHeight;

    Tracking2.callTealiumLink({
      businessEventType: 'userAction',
      componentPath: `${this.componentPath}.toggle`,
      componentName: 'infobox',
      componentLabel: this.toggleText,
      elementTagName: 'a',
      eventType: 'mousedown'
    });
  }

  render() {
    return html`
    <div class="panel">
     <slot name="header"></slot>
     <div class="content-wrapper">
        <div class="content" style="height: ${this.height}px">
          <slot name="content" @slotchange="${this.slotContentChangeHandler}"></slot>
        </div>
        ${this.showToggle ? html`
        <a class="toggle" @click="${this.toggleClickHandler}">
          <strong>${this.toggleText}</strong>
          <span class="icon icon-arrow-down"></span>
        </a>
        ` : null}
      </div>
    </div>`;
  }
}
